import styled, { css, Keyframes, keyframes } from 'styled-components';
import { Button } from 'components/Button';
import { DEVICE } from 'constants/app/breakpoints';

export const PurchaseWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  border: 1px solid var(--v3-black-2);
  border-radius: 16px;
  padding: 20px;
  text-align: left;
`;

export const PurchaseBlock = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 4px;

  @media screen and ${DEVICE.xl} {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: var(--v3-black-0);
    padding: 16px 24px 24px;
    z-index: 10;
  }
`;

export const gradient = keyframes`
  50% {
    background-position: 140% 50%;
  }
`;

export const PurchaseButton = styled(Button)<{
  $glowing?: boolean;
  $gradient?: Keyframes;
}>`
  &&&& {
    border-radius: 12px;
    ${props =>
      props.$glowing
        ? css`
            position: relative;
            justify-content: center;
            background: linear-gradient(
              -90deg,
              #ee7752,
              #e73c7e,
              #23a6d5,
              #23d5ab,
              #ee7752
            );
            background-size: 400% 100%;
            border: none;
            padding: 0;
            animation: ${props.$gradient} 4s ease infinite;
            cursor: pointer;

            & > div {
              display: flex;
              align-items: center;
              color: var(--v3-text-color-inverse);
              mix-blend-mode: overlay;
              font-weight: 500;
              font-size: 20px;
              line-height: 32px;
              white-space: nowrap;
            }
          `
        : css`
          &, & > div {
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            font-size: 15px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px;
          `}
  }
`;

export const NftDetailsPlainSection = styled.div`
  width: 100%;
`;
